<template>
  <div>
        <div>
          <vxe-grid  ref="xTree" :data="tableData"
                    style="overflow:hidden"
                    border 
                    resizable
                    show-overflow
                    :show-header="true"
                    highlight-hover-row
                    highlight-current-row                     
                    :tree-config="{children: 'children', accordion: true, line: true, iconOpen: 'vxe-icon--caret-right rotate45', iconClose: 'vxe-icon--caret-right'}"
                    :radio-config="{labelField: 'saleOrgDesc', trigger: 'row'}"
                    @current-change="onChangeTreeNode">
                <vxe-table-column field="saleOrgDesc" title="组织名"   width="20%" type="radio" tree-node></vxe-table-column>
                <vxe-table-column field="saleOrgCode" title="组织码"></vxe-table-column>
          </vxe-grid>
        </div>
  </div>
</template>

<script>
import SaleOrgService from './../service/SaleOrgService.js';
import {listToTree} from 'utils/algorithm/DataStructure'

export default {
   data(){
     return {
            tableData:[]
     }
   },
   created() {
      this.onLoadOrgTree();
   },
   methods:{
      ...SaleOrgService,      
      /**
      * 加载组织树
      */
      onLoadOrgTree(){
            let vm=this;
            vm.loadSaleOrgTree({
                 "page": 1,
	               "pageSize": 1000
                },function(response){
                    if(response){
                       console.log(response);
                       let tree=listToTree(response.data.list,"saleOrgId","parentId");
                       vm.tableData=tree;
                    }
            });
      },
      /**
       * 树节点更改
       */
      onChangeTreeNode({ row }){
        this.$emit("onSelectTreeNode",row);
        this.$emit("onTreeNodeChange",this.$refs.xTree);
      },
      /**
       * 获取选中的行
       */
      getRadioRecord(){
            let dRecords = this.$refs.xTree.getRadioRecord();
            return dRecords;
      },
      /**
       * 刷新销售组织树
       */
      refreshSaleOrgTree(){
        let vm=this;
        vm.loadSaleOrgTree({
                 "page": 1,
	               "pageSize": 1000
                },function(response){
                    if(response){
                       console.log(response);
                       let tree=listToTree(response.data.list,"saleOrgId","parentId");
                       vm.tableData=tree;
                    }
                });
      }
   }
}
</script>